export default __webpack_public_path__ + "assets/margin-onboarding-5-1f6af343b99368a3d4f8bdd003b6aeda.png";